import { render, staticRenderFns } from "./peopleinfo.vue?vue&type=template&id=2d5965a3&scoped=true&"
import script from "./peopleinfo.vue?vue&type=script&lang=js&"
export * from "./peopleinfo.vue?vue&type=script&lang=js&"
import style0 from "./peopleinfo.vue?vue&type=style&index=0&id=2d5965a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5965a3",
  null
  
)

export default component.exports